<ng-container *ngIf="vm$ | async as vm">
    <ms-widget-header *ngIf="standalone && title" [title]="title" />
    <ng-container *msComponentProxy="teamPagesCompetitionComponent" />
</ng-container>
